import PropTypes from "prop-types"
import React from "react"
import {Page} from "../../constants/page/pages"
import {PagesArchitecture} from "../../constants/page/pagesArchitecture"
import ErrorBoundaryContainer from "../../shared-components/components/ErrorBoundary/errorBoundaryContainer"
import StyleLoaderContainer from "../../shared-components/components/StyleLoader/styleLoaderContainer"
import {SERVIDOM_AREA} from "../../shared-components/constants/areaTypes"
import {getDynamicConfigurationValue} from "../../store/selectors/localStorage/dynamicConfigurationSelectors"
import {areCustomizedStyle, getStyle} from "../../store/selectors/localStorage/styleSelectors"
import {getTexts, isCustomizedTexts} from "../../store/selectors/localStorage/textSelector"
import {AREA_TYPE} from "../../constants/areaType"

const StyleLoaderLayout = ({children}) => {
    return (
        <StyleLoaderContainer
            espaceType={AREA_TYPE}
            getDynamicConfigurationValue={getDynamicConfigurationValue}
            getStyle={getStyle}
            getTexts={getTexts}
            isCustomizedStyle={areCustomizedStyle}
            isCustomizedTexts={isCustomizedTexts}
        >
            <ErrorBoundaryContainer routeToRedirect={PagesArchitecture[Page.HOME].route}>
                {children}
            </ErrorBoundaryContainer>
        </StyleLoaderContainer>
    )
}

StyleLoaderLayout.propTypes = {
    children: PropTypes.node.isRequired,
    isSmallClient: PropTypes.bool.isRequired,
    isSocialContract: PropTypes.bool.isRequired,
}

export default StyleLoaderLayout
